export const ACTIVITY_ASSIGNED_EVENT = 'activity_assigned';
export const ASSIGNMENT_UPDATED_EVENT = 'assignment_updated';
export const PULL_TO_LESSON_EVENT = 'pull-to-lesson';
